import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';

export const useSessionTimeout = (timeoutMinutes: number = 15) => {
  const { signOut, user } = useAuth();

  useEffect(() => {
    if (!user) return;

    let timeoutId: NodeJS.Timeout;
    let warningId: NodeJS.Timeout;

    const resetTimeout = () => {
      clearTimeout(timeoutId);
      clearTimeout(warningId);

      // Warning 3 minutes before timeout for shorter sessions
      const warningTime = Math.max(3, timeoutMinutes - 3);
      warningId = setTimeout(() => {
        const shouldContinue = confirm(
          `Your session will expire in ${timeoutMinutes - warningTime} minutes. Click OK to continue your session.`
        );
        if (!shouldContinue) {
          signOut();
        }
      }, warningTime * 60 * 1000);

      // Auto logout after timeout
      timeoutId = setTimeout(() => {
        alert('Your session has expired. Please sign in again.');
        signOut();
      }, timeoutMinutes * 60 * 1000);
    };

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    const resetTimeoutHandler = () => resetTimeout();
    
    // Set initial timeout
    resetTimeout();

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, resetTimeoutHandler, true);
    });

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(warningId);
      events.forEach(event => {
        document.removeEventListener(event, resetTimeoutHandler, true);
      });
    };
  }, [user, signOut, timeoutMinutes]);
};